export const AUDIO_DELETE_RESET = 'AUDIO_DELETE_RESET';
export const AUDIO_DELETE_SET_ERROR = 'AUDIO_DELETE_SET_ERROR';
export const AUDIO_DELETE_SET_DELETED = 'AUDIO_DELETE_SET_DELETED';
export const AUDIO_DELETE_TOGGLE_LOADING = 'AUDIO_DELETE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/audio/delete/mutation_types.js